
<script>
export default {
  name: 'Capp',
  data() {
    return {

    }
  },
  watch: {
    $route(newVal) {
      if (window.__MICRO_APP_ENVIRONMENT__) {
        const { route: parentRoute } = window.microApp.getData();
        console.log(parentRoute,'parentRoute')

        // 获取当前路由
        const { path, query } = newVal;
        // 获取主应用路由前缀
        const prefix = window.__MICRO_APP_BASE_ROUTE__ || '';
        // 拼接主应用路由
        const currentNewPath = `${prefix}${path}`;

        // 获取主应用路由
        const { path: parentPath, query: parentQuery } = parentRoute;
        // 判断当前路由是否发生变化
        if (currentNewPath !== parentPath || JSON.stringify(parentQuery) !== JSON.stringify(query)) {
          const baseRouter = window.microApp.router.getBaseAppRouter();
          console.log({ path: `${currentNewPath}`, query },111111111111111)
          baseRouter.replace({ path: `${currentNewPath}`, query });
        }
      }
    }
  },
}
</script>
<template>
  <div id="app">

    <!-- consignor
    <div>
      <a href="./consignor.html?v=2.1.1/#/">consignor index</a>
      <a href="./consignor.html?v=2.1.1/#/login">consignor login</a>
      <a href="./group.html?v=2.1.1/#/">group index</a>
      <a href="./group.html?v=2.1.1/#/login">group login</a>
    </div>
    <div id="nav">
      <router-link to="/">index</router-link> |
      <router-link to="/login">login</router-link>
    </div> -->
    <router-view />
  </div>
</template>

<style lang="stylus">
#app {
  // height 100%
  // overflow-y scroll
}
</style>
